var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0281 9.96443C18.0281 9.55021 17.6923 9.21443 17.2781 9.21443L14.7855 9.21443V6.72179C14.7855 6.30757 14.4497 5.97179 14.0355 5.97179C13.6213 5.97179 13.2855 6.30757 13.2855 6.72179V9.96443C13.2855 10.3786 13.6213 10.7144 14.0355 10.7144L17.2781 10.7144C17.6923 10.7144 18.0281 10.3786 18.0281 9.96443Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0355 18.0281C14.4497 18.0281 14.7855 17.6923 14.7855 17.2781L14.7855 14.7855L17.2781 14.7855C17.6924 14.7855 18.0281 14.4497 18.0281 14.0355C18.0281 13.6213 17.6924 13.2855 17.2781 13.2855L14.0355 13.2855C13.6213 13.2855 13.2855 13.6213 13.2855 14.0355L13.2855 17.2781C13.2855 17.6923 13.6213 18.0281 14.0355 18.0281Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.96443 18.0281C9.55021 18.0281 9.21443 17.6923 9.21443 17.2781V14.7855H6.72179C6.30757 14.7855 5.97179 14.4497 5.97179 14.0355C5.97179 13.6213 6.30757 13.2855 6.72179 13.2855L9.96443 13.2855C10.3786 13.2855 10.7144 13.6213 10.7144 14.0355L10.7144 17.2781C10.7144 17.6923 10.3786 18.0281 9.96443 18.0281Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.97181 9.96443C5.97181 9.55021 6.3076 9.21443 6.72181 9.21443H9.21445L9.21445 6.72179C9.21445 6.30757 9.55024 5.97179 9.96445 5.97179C10.3787 5.97179 10.7145 6.30757 10.7145 6.72179L10.7145 9.96443C10.7145 10.3786 10.3787 10.7144 9.96445 10.7144L6.72181 10.7144C6.3076 10.7144 5.97181 10.3786 5.97181 9.96443Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandVideoIcon);
export default __webpack_public_path__ + "static/media/expandVideoIcon.6f32b29e7152701dee6800a700354d55.svg";
export { ForwardRef as ReactComponent };